@let isDesktop = breakpoints() === "desktop";
<section class="centered-with-padding flex flex-col gap-y-5 py-7">
  <div class="grid grid-cols-1 gap-x-5 desk:grid-cols-[auto_543px]">
    <div class="flex flex-col gap-y-5">
      @if (data.title; as title) {
        <app-title [title]="title" size="h2" />
      }
      @let dates = timeslots();
      @if (!isTimeslotsError() && dates) {
        @if (store().isVisioAppointmentAvailable) {
          <div class="flex gap-x-5">
            <label class="inline-flex cursor-pointer items-center space-x-2">
              <input
                (change)="visioAppointmentSelected.set(false)"
                [checked]="!visioAppointmentSelected()"
                name="rdvMode"
                type="radio" />
              <span>{{ "COMPONENT.AGENDA-MAGASIN-TUNNEL.IN_STORE" | translate }}</span>
            </label>

            <label class="inline-flex cursor-pointer items-center space-x-2">
              <input
                (change)="visioAppointmentSelected.set(true)"
                [checked]="visioAppointmentSelected()"
                name="rdvMode"
                type="radio" />
              <span>{{ "COMPONENT.AGENDA-MAGASIN-TUNNEL.REMOTELY" | translate }}</span>
            </label>
          </div>
        }

        @for (dateSlot of dates; track dateSlot.dateLabel) {
          <div class="flex flex-col gap-y-3.5 rounded-xl bg-anis px-4 py-5 font-bold desk:gap-y-4">
            <div (click)="toggleSlot(dateSlot.dateLabel)" class="flex cursor-pointer items-center justify-between">
              <span>{{ dateSlot.dateLabel | transformFirstLetter }}</span>
              <div class="min-h-[15px] min-w-[15px]"></div>
              <app-svg
                [height]="15"
                [inline]="true"
                [ngClass]="{
                  'rotate-90': !slotClosed().has(dateSlot.dateLabel),
                }"
                class="transition-transform duration-300 ease-in-out"
                src="./assets/icons/caret-right.svg" />
            </div>
            @if (!slotClosed().has(dateSlot.dateLabel)) {
              <div class="flex flex-wrap gap-x-2 gap-y-3.5 desk:gap-y-4">
                @for (slot of dateSlot.formattedSlots; track slot.startDate; let i = $index) {
                  <div
                    (click)="onSlotClick(dateSlot, slot)"
                    [ngClass]="{ 'desk:hidden': i >= getSlotCount(dateSlot) }"
                    class="drop-shadow-custom flex h-9 w-16 cursor-pointer items-center justify-center rounded-[10px] bg-white">
                    {{ slot.slot }}
                  </div>
                }
                @if (hasMoreSlots(dateSlot)) {
                  <div
                    (click)="showMoreSlots(dateSlot)"
                    class="drop-shadow-custom hidden h-9 w-16 cursor-pointer items-center justify-center rounded-[10px] bg-white desk:flex">
                    +
                  </div>
                }
                @if (dateSlot.formattedSlots.length === 0) {
                  @if (store().phone; as phone) {
                    @let buttonLabel = "GLOBAL.CALL_TO_ACTION_CALL_US" | translate;
                    @let gtm = data.gtmConfigCallBtn;
                    <a
                      (click)="
                        emitGtmEvent({
                          event: gtm?.event,
                          group: gtm?.group,
                          description: gtm?.description,
                          context: gtm?.context,
                          button_text_value: buttonLabel,
                          event_type: 'click',
                        })
                      "
                      [href]="phone.telLink"
                      class="drop-shadow-custom flex h-9 w-[176px] cursor-pointer items-center justify-center gap-x-2.5 rounded-[10px] bg-white px-2">
                      <span>{{ buttonLabel }}</span>
                      <app-svg [height]="16" src="assets/icons/phone.svg" />
                    </a>
                  }
                }
              </div>
            }
          </div>
        }
        <app-button
          (onButtonClick)="goToFunnel()"
          [label]="'GLOBAL.SEE_MORE_TIME_SLOTS' | translate"
          class="self-center" />
      } @else if (!isTimeslotsError()) {
        <app-loader [text]="'GLOBAL.LOADING_TIME_SLOTS' | translate" class="pt-10" />
      } @else if (isTimeslotsError() && store()) {
        <div class="my-auto desk:-translate-y-16">
          <app-no-slot-fallback-card [store]="store()" />
        </div>
      }
    </div>
    <div class="hidden desk:block">
      @defer (when isDesktop) {
        @if (data.image; as image) {
          <div class="mask-blob-ratio-0_889">
            <app-image [image]="image" [pregenerationSize]="{ width: 543, height: 611 }" />
          </div>
        }
      }
    </div>
  </div>
</section>
